(function ($) {
  if (!$('[data-aos]').length) return;
  $(function () {
    AOS.init();
  });
})(jQuery);
